import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class MultipleInventoryField extends Component {

	static PropTypes = {
		data : PropTypes.any,
		val : PropTypes.any
	}

	state = {
		data : [{id : 1,name : 'inventory'}],
		count : [],
		val : '',
		max : 0
	}

	componentDidMount() {
		this.setState({
			data : this.props.data,
			val : this.props.val
		},() => {
			$('.selectpicker').selectpicker('refresh');
		});

		$('.listInventory').on('changed.bs.select', (e) => {
			let qty = $(e.target).find('option:selected').data('qty');
			let max = qty;

			this.setState({max});
		});
	}

	handleLimitField = (e) => {

		if(Number(e.target.value) > e.target.getAttribute('max'))
		{
			e.target.value = '';
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data : nextProps.data,
			val : nextProps.val
		},() => {
			$('.selectpicker').selectpicker('refresh');
		});
	}

	handleOnClickInventory = (e) => {

		if($(e.target).hasClass('blue'))
		{
			this.props.onAddedItem(this.props.index);
			return;
		}

		this.props.onDeleteItem(this.props.index);
		
	}

	handleOnChange = (e) => {
		this.setState({val : e.target.value});
		this.props.updateValue(e.target.value, this.props.index);
	}

	render() {
		let list = this.state.data;

		let buttonColor = "red";
        let buttonClassname = "fa fa-times red";

        if (this.props.index === this.props.totalIndex - 1) {
            buttonColor = "blue";
            buttonClassname = 'fa fa-plus blue';
        }

		return(
			<div className="row per_content">
				<div className="col-md-5">
					<div className="form-group form-md-line-input">
						<select className="form-control selectpicker listInventory" data-live-search="true" data-size="4" title="Select item" name={this.props.itemId} value={this.state.val} onChange={this.handleOnChange}>
							{list.map((inventory, i) => {
								return <option data-qty={inventory.quantity} key={i} value={inventory.id}>{inventory.name}</option>
							})}
						</select>
						<label className="control-label">Item</label>
					</div>
				</div>
				<div className="col-md-5">
					<div className="form-group form-md-line-input">
						<input type="number" className="form-control" name={this.props.quantityId} max={this.state.max} onChange={this.handleLimitField}/>
						<span className="help-block">{'Limited to ' + this.state.max}</span>
						<label className="control-label">Quantity</label>
					</div>
				</div>
				<div className="col-md-2">
					<span className="input-group-btn btn-right" style={{paddingTop: '20px'}}>
                        <a href="#" className={'btn btn-circle btn-icon-only ' + buttonColor} onClick={this.handleOnClickInventory}>
                            <i className={buttonClassname}/>
                        </a>
                    </span>
				</div>
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/MultipleInventoryField.js
 **/